import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postLogin = async ({ payload }) => {
  const { data } = await SigliveServiceV1({ method: 'POST', url: '/login', data: payload });

  return data;
};

export default postLogin;
